/**
 * Shared hex string utilities for address validation and type narrowing.
 *
 * Consolidates duplicated isHexAddress / isHexString / toHex patterns
 * from use-pool-state, use-swap, TradePanel, and swap-execution.
 */

/** Narrow a string to a hex address via regex validation (40 hex chars after 0x). */
export function isHexAddress(value: string): value is `0x${string}` {
	return /^0x[a-fA-F0-9]{40}$/.test(value);
}

/** Check if a string has a 0x prefix. */
export function isHexString(value: string): value is `0x${string}` {
	return value.startsWith("0x");
}

/**
 * Convert an address string to a validated lowercase 0x-prefixed hex address.
 * Throws if the string does not have a 0x prefix.
 */
export function toCheckedHex(address: string): `0x${string}` {
	const lower = address.toLowerCase();
	if (!isHexString(lower)) {
		// eslint-disable-next-line no-restricted-syntax -- TanStack Query queryFn requires thrown errors
		throw new Error(`Invalid hex address: ${address}`);
	}
	return lower;
}
